import axios from 'axios'

const LOCAL_URL = process.env.REACT_APP_LOCALHOST
const API_TOKEN = localStorage.getItem('api_token') || ''

export const SUBSCRIPTION_LIST = `${LOCAL_URL}/subscriptionPlans`
export const CHOOSE_PLAN = `${LOCAL_URL}/createSubscription`

const headers = {
  Authorization: API_TOKEN,
}

// function to get all the subscription plans
export async function getSubscriptionList() {
  return await axios.get(SUBSCRIPTION_LIST, { headers})
}

// function to choose subscription plan by the user
export async function chooseSubscriptionPlan(subscription_uuid:string) {
  return await axios.post(CHOOSE_PLAN, {
    subscription_uuid
  })
}
